import * as React from "react";
import { capitalizeFirstLetter } from "@vebox/etui-core";
import { LoadingButton } from "../../../../../components/buttons/LoadingButton";

import { AppTranslations } from "../../../../../components/Utils/translations/AppTranslations";

declare var AppTranslations: AppTranslations;

interface DownloadCSVProps {
	data: any;
	fileName: string;
}

const fileNamePlusDate = (fileName: string) => {
	const date = new Date();
	const pad = (num: number) => num.toString().padStart(2, "0");
	return `${fileName}_${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}${pad(
		date.getHours(),
	)}${pad(date.getMinutes())}`;
};

export const DownloadCSV: React.FC<DownloadCSVProps> = ({ data, fileName }) => {
	const [isExporting, setIsExporting] = React.useState(false);

	const convertToCSV = (objArray) => {
		const array =
			typeof objArray !== "object" ? JSON.parse(objArray) : objArray;
		let str = "";

		for (let i = 0; i < array.length; i++) {
			let line = "";
			for (let index in array[i]) {
				if (line !== "") line += ";";

				line += array[i][index];
			}
			str += line + "\r\n";
		}
		return str;
	};

	const downloadCSV = () => {
		setIsExporting(true);
		const csvData = new Blob(["\ufeff", convertToCSV(data)], {
			type: "text/csv",
		});
		const csvURL = URL.createObjectURL(csvData);
		const link = document.createElement("a");
		link.href = csvURL;
		link.download = `${fileNamePlusDate(fileName)}.csv`;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		setIsExporting(false);
	};

	return (
		<LoadingButton
			variant={"strong"}
			onClick={downloadCSV}
			loading={isExporting}
			small={true}
		>
			{capitalizeFirstLetter(
				AppTranslations.massiveActions.censusCooler.exportInvalidCodes,
			)}
		</LoadingButton>
	);
};
